import { useCallback, useRef } from 'react';

const useBodyScrollLock = () => {
    const noPassive = useRef<AddEventListenerOptions>({ passive: false });

    const preventScroll = useCallback((e: WheelEvent | TouchEvent) => {
        e.preventDefault();
    }, []);

    const lockScroll = useCallback(() => {
        window.addEventListener('wheel',     preventScroll, noPassive.current);
        window.addEventListener('touchmove', preventScroll, noPassive.current);
    }, [preventScroll]);

    const unlockScroll = useCallback(() => {
        window.removeEventListener('wheel',     preventScroll, noPassive.current);
        window.removeEventListener('touchmove', preventScroll, noPassive.current);
    }, [preventScroll]);

    return { lockScroll, unlockScroll };
};

export default useBodyScrollLock;
